import {
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  MenuItem,
  TextField as MUITextField,
  Typography,
} from "@material-ui/core";
import { Field, Form, withFormik } from "formik";
import React from "react";
import { withTranslation } from "react-i18next";
import { CheckboxWithLabel, Switch, TextField } from "formik-material-ui";
import CitySearch from "../../common/CitySearch";
import PropTypes from "prop-types";
import network from "../../../actions/external/network";
import { setSelectedExploitation } from "../../../actions/exploitation";
import { connect } from "react-redux";
import { isEmail } from "../../common/validators";
import { toastr } from "react-redux-toastr";
import { replaceEmptyStringByNull, replaceNullByEmptyString } from "../../../scripts/utils";
import { Alert, AlertTitle } from "@material-ui/lab";
import "./ModifExploitationForm.scss";

const mapStateToProps = (state) => ({
  exploitationSelected: state.exploitation.selected,
  organisme: state.organisme.selected,
  app: state.app,
});

const mapDispatchToProps = (dispatch) => ({
  updateExploitation: (newExploitation) => dispatch(setSelectedExploitation(newExploitation)),
});

class ModifExploitationForm extends React.Component {
  setPreviousInfos = async () => {
    const { setFieldValue, familleCultures, expInfosMillesimePrecedent, idExploitation, idMillesime } = this.props;
    Object.entries(expInfosMillesimePrecedent).forEach(([key, value]) => {
      setFieldValue(key, value);
    });
    const [expActivites, expFamilleCultures] = await Promise.all([
      network.fetch(`/api/exploitations/${idExploitation}/activities?millesime=${idMillesime - 1}`),
      network.fetch(`/api/exploitations/${idExploitation}/familles-cultures?millesime=${idMillesime - 1}`),
    ]);
    setFieldValue("idActivitePrincipale", expActivites.principal.idActivite, true);
    setFieldValue("idActiviteSecondaire", expActivites.secondaire.idActivite, true);
    familleCultures.forEach((fc) => setFieldValue(`exploitationFamilleCultures.${fc.codeNational}.checked`, false));
    expFamilleCultures.forEach((expFamilleCulture) => {
      setFieldValue(`exploitationFamilleCultures.${expFamilleCulture.codeNational}.checked`, true);
      if (expFamilleCulture.codeNational === "VITIC") {
        setFieldValue(
          `exploitationFamilleCultures.${expFamilleCulture.codeNational}.code`,
          expFamilleCulture.estCvi ? "CVI" : "SAU"
        );
      }
    });
  };

  componentDidMount = async () => {
    const { values } = this.props;
    values.idCommune && this.fetchEntiteParentes(values.commune);
  };

  fetchEntiteParentes = async (commune) => {
    const { setFieldValue } = this.props;
    try {
      if (commune != null) {
        const [entiteDepartement, entiteRegion] = await Promise.all([
          network.fetch(`/api/entites/commune?idCommune=${commune.idcommune}`),
          network.fetch(`/api/entites/parente?idEntite=${commune.identite}`),
        ]);
        setFieldValue("entiteDepartement", entiteDepartement);
        setFieldValue("entiteRegion", entiteRegion);
        setFieldValue("departement", entiteDepartement.libelleentite, true);
        setFieldValue("region", entiteRegion.libelleentite, true);
      }
    } catch (e) {}
  };

  handlePrecisionDepartementChange = (event) => {
    const { setFieldValue, values, departementPrecisions, bassinViti } = this.props;

    setFieldValue("idDepartementPrecision", event.target.value);
    const departementPrecision = departementPrecisions.find(
      (d) => d.idDepartementPrecision === event.target.value && d.identite === values.entiteDepartement.identite
    );

    switch (values.entiteDepartement.codeentite) {
      //ARDECHE ou DROME
      case "007":
      case "026": {
        const codeBassin = departementPrecision?.codePrecisionDepartement === "SUD" ? "CRHS" : "CRHN";
        const bassin = bassinViti.find((bassin) => bassin.codeBassin === codeBassin);
        setFieldValue("idBassinViti", bassin.idBassinViti);
        break;
      }
      //RHONE
      case "069": {
        const codeBassin = departementPrecision?.codePrecisionDepartement === "AOC-BEAU" ? "BEAU" : "AUT-RPV";
        const bassin = bassinViti.find((bassin) => bassin.codeBassin === codeBassin);
        setFieldValue("idBassinViti", bassin.idBassinViti);
        break;
      }
      //SAONE-ET-LOIRE
      case "071": {
        const codeBassin = departementPrecision?.codePrecisionDepartement === "AOC-BEAU" ? "BEAU" : "BOUR";
        const bassin = bassinViti.find((bassin) => bassin.codeBassin === codeBassin);
        setFieldValue("idBassinViti", bassin.idBassinViti);
        break;
      }
      default:
        setFieldValue("idBassinViti", null);
    }
  };

  renderInformationsGenerales = () => {
    const {
      t,
      validateForm,
      setFieldValue,
      values,
      errors,
      touched,
      setFieldTouched,
      expInfosMillesimePrecedent,
      idMillesime,
      bassinViti,
      OTEX,
      statutJuridiques,
      departementPrecisions,
    } = this.props;
    const changeCity = async ({ value }) => {
      setFieldTouched("commune", true, false);
      setFieldValue("commune", value, true);
      setFieldValue("idBassinViti", null);
      await this.fetchEntiteParentes(value);
      validateForm();
    };
    const changeBassinViti = (event) => {
      setFieldValue("idBassinViti", event.target.value, true);
      validateForm();
    };
    /**
     * Vérifie que le champ comporte que des chiffres et vérifie sa longueur
     * @param event input element
     * @param componentName nom de l'élément sur lequel la vérification est éffectué
     * @param maxLength longueur max du champ (10 par défaut)
     */
    const validateNumber = (event, componentName, maxLength = 10) => {
      let input = event.target.value;
      //remplace tout ce qui n'est pas un chiffre par une chaine vide
      input = input.replace(/\D/g, "");
      if (input.length > maxLength) {
        input = input.slice(0, maxLength);
      }
      setFieldValue(componentName, input, true);
    };
    const renderPrecisionDepartement = departementPrecisions?.some(
      (departementPrecision) => departementPrecision.identite === values.commune?.identite
    );

    return (
      <div>
        <span className="align-self-start d-flex justify-between align-items-center mb-2">
          <div className="d-flex align-items-center">
            <Typography variant="h3" component="h2">
              {t("modif-exploitation.infos", "Informations générales")}
            </Typography>
            <Typography variant="body2" className="ml-1" style={{ fontSize: "smaller" }}>
              <i>informations inter-millésimes</i>
            </Typography>
          </div>
          {Object.keys(expInfosMillesimePrecedent).length > 0 && (
            <Button variant={"text"} onClick={this.setPreviousInfos}>
              Reprendre les données de {idMillesime - 1}
            </Button>
          )}
        </span>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <Field
              component={TextField}
              label={t("modif-exploitation.company-name", "Raison sociale")}
              name="raisonSociale"
              required
              error={errors.raisonSociale ? errors.raisonSociale : ""}
              helperText={errors.raisonSociale ? errors.raisonSociale : ""}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <Field
              // Les navigateurs ne supportent pas l'autocomplete "off" pour la plupart donc on est obligé de mettre ça
              // en type "cryptogramme visuel" de carte de crédit pour que l'autocomplete arrête de traiter le champ
              // comme un champ de ... carte de crédit.............. Le dev web était une erreur
              // https://developer.mozilla.org/en-US/docs/Web/Security/Practical_implementation_guides/Turning_off_form_autocompletion#the_autocomplete_attribute_and_login_fields
              // https://stackoverflow.com/questions/64118290/why-does-chrome-think-that-my-form-is-a-credit-card-form
              inputProps={{ autocomplete: "cc-csc" }}
              component={TextField}
              label={t("modif-exploitation.siret-number", "Numéro SIRET")}
              onChange={(event) => validateNumber(event, "siret", 14)}
              name="siret"
              pattern="^[0-9]{14}$"
              maxLength={14}
              error={errors.siret ? errors.siret : ""}
              helperText={errors.siret ? errors.siret : ""}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <Field
              component={TextField}
              label={t("modif-exploitation.user-last-name", "Nom de l'exploitant")}
              name="nomExploitant"
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <Field
              component={TextField}
              label={t("modif-exploitation.user-first-name", "Prénom de l'exploitant")}
              name="prenomExploitant"
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <Field
              component={TextField}
              label={t("modif-exploitation.pacage", "N° Pacage")}
              name="pacage"
              maxLength={9}
              error={errors.pacage ? errors.pacage : ""}
              helperText={errors.pacage ? errors.pacage : ""}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <Field
              component={TextField}
              label={t("modif-exploitation.address", "Adresse")}
              name="adresse"
              required
              error={errors.adresse ? errors.adresse : ""}
              helperText={errors.adresse ? errors.adresse : ""}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <Field component={TextField} label={t("modif-exploitation.address2", "Adresse2")} name="adresse2" />
          </Grid>
          <Grid item xs={12} lg={6}>
            <CitySearch
              label={t("modif-exploitation.city", "Commune")}
              name="commune"
              onChange={(...params) => changeCity(...params)}
              value={values.commune ?? ""}
              touched={touched["commune"]}
              error={errors.commune ? errors.commune : ""}
              helperText={errors.commune ? errors.commune : ""}
              required
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <Field
              component={TextField}
              label={t("modif-exploitation.adresseMail", "Email")}
              name="adresseMail"
              pattern="^.+@.+\..+$"
              required
              error={errors.adresseMail ? errors.adresseMail : ""}
              helperText={errors.adresseMail ? errors.adresseMail : ""}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <Field
              component={TextField}
              label={t("modif-exploitation.numeroPortable", "Numéro de téléphone portable")}
              name="numeroPortable"
              onChange={(event) => validateNumber(event, "numeroPortable")}
              error={errors.numeroPortable ? errors.numeroPortable : ""}
              helperText={errors.numeroPortable ? errors.numeroPortable : ""}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <Field
              component={TextField}
              label={t("modif-exploitation.siteInternet", "Site Internet de l'exploitation")}
              name="siteInternet"
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <Field
              component={TextField}
              inputProps={{ pattern: "[0-9]*" }}
              label={t("modif-exploitation.anneeCreation", "Année de création")}
              name="anneeCreation"
            />
          </Grid>

          <Grid item xs={12} lg={6}>
            <Field
              component={TextField}
              label={t("modif-exploitation.statutJuridique", "Statut juridique")}
              name="statutJuridique"
              select
              required
              error={errors.statutJuridique ? errors.statutJuridique : ""}
              helperText={errors.statutJuridique ? errors.statutJuridique : ""}
            >
              {statutJuridiques
                .filter((s) => s.millesimefinvalidite >= idMillesime || s.millesimefinvalidite == null)
                .map((statut) => (
                  <MenuItem key={statut.idStatutJuridique} value={statut.idStatutJuridique}>
                    {statut.libelle}
                  </MenuItem>
                ))}
            </Field>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Field
              type="checkbox"
              component={CheckboxWithLabel}
              name="autorisationReferencement"
              color="primary"
              Label={{
                label: t(
                  "modif-exploitation.autorisationReferencement",
                  "Autorisation de référencement dans l'annuaire"
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <Field
              inputProps={{ pattern: "[0-9]{10}" }}
              component={TextField}
              label={t("modif-exploitation.cvi", "Numéro CVI")}
              name="cvi"
              onChange={(event) => validateNumber(event, "cvi")}
              error={errors.cvi ? errors.cvi : ""}
              helperText={errors.cvi ? errors.cvi : ""}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <MUITextField
              fullWidth
              select={true}
              variant="outlined"
              value={values.idBassinViti ?? ""}
              name="idBassinViti"
              onChange={changeBassinViti}
              label={t("modif-exploitation.idBassinViti", "Bassin Viticole")}
            >
              {bassinViti !== undefined &&
                bassinViti.map((b) => (
                  <MenuItem key={b.idBassinViti} value={b.idBassinViti}>
                    {b.libelle}
                  </MenuItem>
                ))}
            </MUITextField>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Field
              disabled
              component={TextField}
              label={t("modif-exploitation.departement", "Département")}
              name="departement"
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <Field disabled component={TextField} label={t("modif-exploitation.region", "Région")} name="region" />
          </Grid>
          {renderPrecisionDepartement && (
            <Grid item xs={12} lg={6}>
              <Field
                component={TextField}
                label={t("modif-exploitation.departement-precision", "Précision département")}
                name="idDepartementPrecision"
                value={values.idDepartementPrecision}
                onChange={(event) => this.handlePrecisionDepartementChange(event)}
                select
              >
                {departementPrecisions
                  ?.filter((departementPrecision) => departementPrecision.identite === values.commune?.identite)
                  ?.map((departementPrecision) => {
                    return (
                      <MenuItem
                        key={departementPrecision.idDepartementPrecision}
                        value={departementPrecision.idDepartementPrecision}
                      >
                        {departementPrecision.libelle}
                      </MenuItem>
                    );
                  })}
              </Field>
            </Grid>
          )}
          <Grid item xs={6} lg={2}>
            <FormControlLabel
              control={<Field component={Switch} color="primary" name="venteDirecte" type="checkbox" />}
              label={t("modif-exploitation.activity-direct-selling", "Vente directe")}
              labelPlacement="start"
            />
          </Grid>
          <Grid item xs={12} lg={3}>
            <Field
              component={TextField}
              select
              variant="outlined"
              fullWidth
              label={"OTEX"}
              name="otex"
              onChange={this.changeOtex}
            >
              {OTEX.map((a) => (
                <MenuItem key={a.codeNational} value={a.codeNational}>
                  {`${a.codeNational} - ${a.libelle}`}
                </MenuItem>
              ))}
            </Field>
          </Grid>
        </Grid>
      </div>
    );
  };

  changeActivitePrincipale = (event) => {
    const { setFieldValue, validateForm, values } = this.props;
    switch (event.target.name) {
      case "idActiviteVegetalePrincipale": {
        if (event.target.value === values.idActiviteVegetaleSecondaire)
          setFieldValue("idActiviteVegetaleSecondaire", null, true);
        break;
      }
      case "idActiviteAnimalePrincipale": {
        if (event.target.value === values.idActiviteAnimaleSecondaire)
          setFieldValue("idActiviteAnimaleSecondaire", null, true);
        break;
      }
      default: {
        break;
      }
    }
    setFieldValue(
      "idsActivitesAutres",
      values.idsActivitesAutres.filter((i) => i !== event.target.value),
      true
    );
    setFieldValue(event.target.name, event.target.value, true);
    validateForm();
  };

  changeActiviteSecondaire = (event) => {
    const { setFieldValue, validateForm, values } = this.props;
    setFieldValue(
      "idsActivitesAutres",
      values.idsActivitesAutres.filter((i) => i !== event.target.value),
      false
    );
    setFieldValue(event.target.name, event.target.value, true);
    validateForm();
  };

  changeOtex = (event) => {
    const { setFieldValue, validateForm } = this.props;
    setFieldValue(event.target.name, event.target.value, true);
    validateForm();
  };

  renderActivitesAnimales = () => {
    const { t, values, activites, touched, errors, setFieldTouched } = this.props;
    const activitesAnimales = activites.filter((a) => a.typeActivite === "ANIMALE");
    const activitesAnimalesSecondaires = activitesAnimales.filter(
      (a) => a.idActivite !== values.idActiviteAnimalePrincipale
    );
    const activitesAnimalesAutres = activitesAnimalesSecondaires.filter(
      (a) => a.idActivite !== values.idActiviteAnimaleSecondaire
    );

    return (
      <React.Fragment>
        <Typography variant="h3" component="h2" className="mb-2 align-self-start">
          {t("modif-exploitation.animalActivities", "Gestion des activités animales")}
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={4}>
            <MUITextField
              fullWidth
              select={true}
              variant="outlined"
              label={t("modif-exploitation.activity-primary", "Activité principale")}
              SelectProps={{
                onOpen: () => {
                  setFieldTouched("idActiviteAnimalePrincipale");
                },
              }}
              name={"idActiviteAnimalePrincipale"}
              value={values.idActiviteAnimalePrincipale}
              onChange={this.changeActivitePrincipale}
              error={!!errors.idActiviteAnimalePrincipale && touched.idActiviteAnimalePrincipale}
              helperText={touched.idActiviteAnimalePrincipale && errors.idActiviteAnimalePrincipale}
            >
              <MenuItem key={null} value={null}>
                <i>Aucune</i>
              </MenuItem>
              {activitesAnimales.map((a) => (
                <MenuItem key={a.idActivite} value={a.idActivite}>
                  {a.libelle}
                </MenuItem>
              ))}
            </MUITextField>
          </Grid>
          <Grid item xs={12} lg={4}>
            <Field
              component={TextField}
              select
              variant="outlined"
              fullWidth
              label={"Activité secondaire"}
              name="idActiviteAnimaleSecondaire"
              onChange={this.changeActiviteSecondaire}
            >
              <MenuItem key={null} value={null}>
                <i>Aucune</i>
              </MenuItem>
              {activitesAnimalesSecondaires.map((a) => (
                <MenuItem key={a.idActivite} value={a.idActivite}>
                  {a.libelle}
                </MenuItem>
              ))}
            </Field>
          </Grid>
          <Grid item xs={12} lg={4}>
            <Field
              component={TextField}
              select
              SelectProps={{ multiple: true }}
              variant="outlined"
              fullWidth
              label={t("modif-exploitation.activity-other", "Autres activités")}
              name="idsActivitesAutres"
            >
              {activitesAnimalesAutres.map((a) => (
                <MenuItem key={a.idActivite} value={a.idActivite}>
                  {a.libelle}
                </MenuItem>
              ))}
            </Field>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Field
              component={TextField}
              multiline
              rows={3}
              label={t(
                "modif-exploitation.activity-engagement",
                "Engagement dans un autre mode de valorisation officielle"
              )}
              name="engagementValorisation"
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <Field
              component={TextField}
              multiline
              rows={3}
              label={t("modif-exploitation.activity-tracking", "Traçabilité / Source des données")}
              name="tracabilite"
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  renderActivitesVegetales = () => {
    const { t, values, activites, touched, errors, setFieldTouched } = this.props;
    const activitesVegetales = activites.filter((a) => a.typeActivite !== "ANIMALE");
    const activitesVegetalesSecondaires = activitesVegetales.filter(
      (a) => a.idActivite !== values.idActiviteVegetalePrincipale
    );
    const activitesVegetalesAutres = activitesVegetalesSecondaires.filter(
      (a) => a.idActivite !== values.idActiviteVegetaleSecondaire
    );
    return (
      <React.Fragment>
        <Typography variant="h3" component="h2" className="mb-2 align-self-start">
          {t("modif-exploitation.vegetalActivities", "Gestion des activité végétales")}
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={4}>
            <MUITextField
              required
              fullWidth
              select={true}
              variant="outlined"
              label={t("modif-exploitation.activity-primary", "Activité principale")}
              SelectProps={{
                onOpen: () => {
                  setFieldTouched("idActiviteVegetalePrincipale");
                },
              }}
              name={"idActiviteVegetalePrincipale"}
              value={values.idActiviteVegetalePrincipale}
              onChange={this.changeActivitePrincipale}
              error={!!errors.idActiviteVegetalePrincipale && touched.idActiviteVegetalePrincipale}
              helperText={touched.idActiviteVegetalePrincipale && errors.idActiviteVegetalePrincipale}
            >
              <MenuItem key={null} value={null}>
                <i>Aucune</i>
              </MenuItem>
              {activitesVegetales.map((a) => (
                <MenuItem key={a.idActivite} value={a.idActivite}>
                  {a.libelle}
                </MenuItem>
              ))}
            </MUITextField>
          </Grid>
          <Grid item xs={12} lg={4}>
            <Field
              component={TextField}
              select
              variant="outlined"
              fullWidth
              label={t("modif-exploitation.activity-secondary", "Activités secondaires")}
              name="idActiviteVegetaleSecondaire"
              onChange={this.changeActiviteSecondaire}
            >
              <MenuItem key={null} value={null}>
                <i>Aucune</i>
              </MenuItem>
              {activitesVegetalesSecondaires.map((a) => (
                <MenuItem key={a.idActivite} value={a.idActivite}>
                  {a.libelle}
                </MenuItem>
              ))}
            </Field>
          </Grid>
          <Grid item xs={12} lg={4}>
            <Field
              component={TextField}
              select
              SelectProps={{ multiple: true }}
              variant="outlined"
              fullWidth
              label={t("modif-exploitation.activity-other", "Autres activités")}
              name="idsActivitesAutres"
            >
              {activitesVegetalesAutres.map((a) => (
                <MenuItem key={a.idActivite} value={a.idActivite}>
                  {a.libelle}
                </MenuItem>
              ))}
            </Field>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Field
              component={TextField}
              multiline
              rows={3}
              label={t(
                "modif-exploitation.activity-engagement",
                "Engagement dans un autre mode de valorisation officielle"
              )}
              name="engagementValorisationVegetale"
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <Field
              component={TextField}
              multiline
              rows={3}
              label={t("modif-exploitation.activity-tracking", "Traçabilité / Source des données")}
              name="tracabiliteVegetale"
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  renderCultures = () => {
    const { t, values, familleCultures } = this.props;
    return (
      <React.Fragment>
        <Typography variant="h3" component="h2" className="mb-2 align-self-start">
          {t("modif-exploitation.cultures", "Personnalisation des indicateurs")}
        </Typography>
        <Grid container spacing={2} className="d-flex justify-between align-items-start">
          {familleCultures.map((f) => (
            <Grid item xs={6} lg={3} key={f.idFamilleCulture} className="d-flex flex-column">
              <Field
                type="checkbox"
                component={CheckboxWithLabel}
                name={`exploitationFamilleCultures.${f.codeNational}.checked`}
                color="primary"
                Label={{ label: f.libelle }}
              />
              {f.codeNational === "VITIC" && values.exploitationFamilleCultures.VITIC?.checked && (
                <Field
                  component={TextField}
                  select={true}
                  fullWidth={false}
                  label={t("modif-exploitation.init-surface", "Surface initialisée avec")}
                  name="exploitationFamilleCultures.VITIC.code"
                  className="mt-1"
                  required
                >
                  {[
                    {
                      libelle: "la SAU",
                      code: "SAU",
                    },
                    {
                      libelle: "la surface CVI",
                      code: "CVI",
                    },
                  ].map((c) => (
                    <MenuItem key={c.code} value={c.code}>
                      {c.libelle}
                    </MenuItem>
                  ))}
                </Field>
              )}
            </Grid>
          ))}
        </Grid>
        <Grid item xs={6} lg={2}>
          <FormControlLabel
            className={"ml-3 mt-2"}
            style={{ transform: "scale(1.5)" }}
            control={<Field component={Switch} color="primary" name="irrigation" type="checkbox" />}
            label="Irrigation"
            labelPlacement="start"
          />
        </Grid>
      </React.Fragment>
    );
  };

  renderComment = () => {
    const { t } = this.props;
    return (
      <Grid item xs={12} lg={12}>
        <Typography variant="h3" component="h2" className="mb-2 align-self-start">
          {t("modif-exploitation.comment", "Commentaire général")}
        </Typography>
        <Field
          component={TextField}
          multiline
          rows={6}
          name="commentaire"
          label={t("modif-exploitation.comment", "Commentaire général")}
        />
      </Grid>
    );
  };

  renderSubmit = () => {
    const { t, isSubmitting, isValid, isValidating, onCancel } = this.props;
    return (
      <span className="align-self-center">
        <Box className="my-2">
          <Button
            color="primary"
            variant="contained"
            className="mr-1"
            type="submit"
            disabled={isValidating || isSubmitting || !isValid}
          >
            {isValidating || isSubmitting ? (
              <CircularProgress size={24} />
            ) : (
              t("modif-exploitation.validate", "Valider")
            )}
          </Button>
          <Button type="button" variant="contained" onClick={onCancel} disabled={isSubmitting}>
            {t("modif-exploitation.cancel", "Annuler")}
          </Button>
          {!isValid && (
            <Alert severity="error" className="mt-1">
              <AlertTitle>
                <strong>{t("form-missing-data.title", "Impossible de valider")}</strong>
              </AlertTitle>
              {t(
                "form-missing-data.message",
                "Des données sont manquantes ou erronnées lors de la saisie du formulaire."
              )}
            </Alert>
          )}
        </Box>
      </span>
    );
  };

  render() {
    return (
      <Form>
        {this.renderInformationsGenerales()}
        <Divider className="my-4" />
        {this.renderActivitesAnimales()}
        <Divider className="my-4" />
        {this.renderActivitesVegetales()}
        <Divider className="my-4" />
        {this.renderCultures()}
        <Divider className="my-4" />
        {this.renderComment()}
        {this.renderSubmit()}
      </Form>
    );
  }
}

ModifExploitationForm.propTypes = {
  idExploitation: PropTypes.number,
  idMillesime: PropTypes.number.isRequired,
  form: PropTypes.shape({
    siret: PropTypes.string,
    raisonSociale: PropTypes.string,
    pacage: PropTypes.string,
    adresse: PropTypes.string,
    adresse2: PropTypes.string,
    commune: PropTypes.shape({
      idcommune: PropTypes.string,
      nom: PropTypes.string,
      codepostal: PropTypes.string,
    }),
    adresseMail: PropTypes.string,
    statutJuridique: PropTypes.number,
    numeroPortable: PropTypes.string,
    venteDirecte: PropTypes.bool,
    irrigation: PropTypes.bool,
    engagementValorisation: PropTypes.string,
    tracabilite: PropTypes.string,
    commentaire: PropTypes.string,
    idActiviteAnimalePrincipale: PropTypes.number,
    idActiviteVegetalePrincipale: PropTypes.number,
    idActivitePrincipale: PropTypes.array,
    idActiviteAnimaleSecondaire: PropTypes.number,
    idActiviteVegetaleSecondaire: PropTypes.number,
    idActiviteSecondaire: PropTypes.array,
    idsActivitesAutres: PropTypes.array,
    exploitationFamilleCultures: PropTypes.object,
    idDepartementPrecision: PropTypes.number,
  }).isRequired,
  familleCultures: PropTypes.array,
  activites: PropTypes.array,
  afterSubmit: PropTypes.func,
  expInfosMillesimePrecedent: PropTypes.object,
};
export const modifExploitationFormDefault = {
  activites: [],
  familleCultures: [],
  form: {
    siret: "",
    raisonSociale: "",
    pacage: "",
    nomExploitant: "",
    prenomExploitant: "",
    adresse: "",
    adresse2: "",
    commune: {
      idcommune: "",
      nom: "",
      codepostal: "",
    },
    adresseMail: "",
    statutJuridique: "",
    numeroPortable: "",
    venteDirecte: false,
    irrigation: false,
    engagementValorisation: "",
    tracabilite: "",
    commentaire: "",
    idActivitePrincipale: [],
    idActiviteAnimalePrincipale: "",
    idActiviteVegetalePrincipale: "",
    idActiviteSecondaire: [],
    idActiviteAnimaleSecondaire: "",
    idActiviteVegetaleSecondaire: "",
    idsActivitesAutres: [],
    exploitationFamilleCultures: {},
    idDepartementPrecision: "",
    cvi: "",
  },
  expInfosMillesimePrecedent: {},
};

ModifExploitationForm.defaultProps = modifExploitationFormDefault;

const mapPropsToValues = (props) => {
  return replaceNullByEmptyString(props.form, [
    "pacage",
    "numeroPortable",
    "nomExploitant",
    "prenomExploitant",
    "statutJuridique",
  ]);
};

const handleSubmit = async (values, { props, setSubmitting }) => {
  try {
    const idOrganisme = "";
    setSubmitting(true);
    const exploitationFamilleCultures = Object.entries(values.exploitationFamilleCultures)
      .filter(([key, value]) => value.checked)
      .map(([key, value]) => ({
        idFamilleCulture: props.familleCultures.find((fc) => fc.codeNational === key).idFamilleCulture,
        idExploitation: props.idExploitation,
        idMillesime: props.idMillesime,
        estCvi: key !== "VITIC" ? null : value.code === "CVI",
      }));
    const {
      venteDirecte,
      irrigation,
      tracabilite,
      commentaire,
      engagementValorisation,
      commune,
      ...exploitationMain
    } = values;
    const URL = props.idExploitation
      ? `/api/exploitations/${props.idExploitation}?millesime=${props.idMillesime}`
      : `/api/exploitations?millesime=${props.idMillesime}${idOrganisme}`;
    const result = await network.fetch(URL, {
      method: props.idExploitation ? "PUT" : "POST",
      body: JSON.stringify(
        replaceEmptyStringByNull(
          {
            ...exploitationMain,
            idActiviteSecondaire: [values.idActiviteAnimaleSecondaire, values.idActiviteVegetaleSecondaire],
            idActivitePrincipale: [values.idActiviteAnimalePrincipale, values.idActiviteVegetalePrincipale],
            idCommune: commune.idcommune,
            nomCommune: commune.nom,
            exploitationFamilleCultures,
            exploitationInfo: {
              idMillesime: props.idMillesime,
              idExploitation: props.idExploitation,
              irrigation: values.irrigation,
              venteDirecte: values.venteDirecte,
              engagementValorisation: values.engagementValorisation,
              tracabilite: values.tracabilite,
              commentaire: values.commentaire,
              otex: values.otex,
            },
          },
          ["pacage", "numeroPortable"]
        )
      ),
    });
    if (props.exploitationSelected?.idExploitation === exploitationMain.idExploitation) {
      props.updateExploitation({
        ...result,
        ...exploitationMain,
        nomCommune: commune.nom,
        codePostal: commune.codepostal,
        irrigation: values.irrigation,
      });
    }
    toastr.success(
      props.t("saved", "Enregistré"),
      props.t("modif-exploitation.success-save", "L'exploitation a été enregistrée.")
    );
    setSubmitting(false);
    if (props.afterSubmit) {
      props.afterSubmit();
    }
  } catch (error) {
    toastr.error("Erreur", error.message);
  }
};

/**
 * On vérifie que le siret soit valide
 * @param value valeur du siret
 * @returns {boolean} vrai si le siret est conforme
 */
const isSiretValid = (value) => {
  let siret = value.toString().split("");
  if (siret[0] === "0") return true;
  let resultValue = 0;
  for (let i = 0; i < siret.length; i++) {
    if (i % 2 === 0) {
      if (siret[i] * 2 > 9) {
        let result = (siret[i] * 2).toString();
        siret[i] = parseInt(result[0]) + parseInt(result[1]);
      } else {
        siret[i] = siret[i] * 2;
      }
    }
    resultValue += parseInt(siret[i]);
  }
  return resultValue.toString()[1] === "0";
};

const validate = (values, props) => {
  const { t } = props,
    errors = {};
  if (!values.raisonSociale.length) {
    errors.raisonSociale = t("modif-exploitation.error.required", "Champ obligatoire");
  }

  if (values.numeroPortable && values.numeroPortable.length > 0 && values.numeroPortable.length !== 10)
    errors.numeroPortable = t("modif-exploitation.error.wrong-length-number", "Téléphone non valide");

  if (!values.siret?.length && !values.cvi?.length) {
    errors.siret = "Saisir un numéro SIRET ou CVI";
    errors.cvi = "Saisir un numéro SIRET ou CVI";
  } else {
    if (values.siret?.length) {
      if (values.siret.length !== 14) {
        errors.siret = t("modif-exploitation.error.wrong-length-siret", "Le champ doit faire 14 caractères");
      } else if (!isSiretValid(values.siret)) {
        errors.siret = t("modif-exploitation.error.wrong-siret-value", "SIRET non valide");
      }
    }

    if (values.cvi?.length) {
      if (values.cvi.length > 0 && values.cvi.length !== 10) {
        errors.cvi = "Le numéro CVI doit comporter 10 caractères";
      }
    }
  }

  if (![0, 9].includes(values.pacage.length)) {
    errors.pacage = t(
      "modif-exploitation.error.wrong-length-pacage",
      "PACAGE non valide, le champ doit faire 9 caractères"
    );
  }

  if (!values.adresse.length) {
    errors.adresse = t("modif-exploitation.error.required", "Champ obligatoire");
  }
  if (!values.commune?.idcommune.length) {
    errors.commune = t("modif-exploitation.error.required", "Champ obligatoire");
  }

  if (!values.adresseMail?.length) {
    errors.adresseMail = t("modif-exploitation.error.required", "Champ obligatoire");
  } else if (!isEmail(values.adresseMail)) {
    errors.adresseMail = t("modif-exploitation.error.invalid-email", "Format de mail non valide");
  }
  if (values.statutJuridique === "") {
    errors.statutJuridique = t("modif-exploitation.error.required", "Champ obligatoire");
  }
  if (!values.idActiviteAnimalePrincipale && !values.idActiviteVegetalePrincipale) {
    errors.idActiviteAnimalePrincipale = "Saisissez au moins une activité principale";
    errors.idActiviteVegetalePrincipale = "Saisissez au moins une activité principale";
  }
  if (values.exploitationFamilleCultures.VITIC.checked && values.exploitationFamilleCultures.VITIC.code === "") {
    errors.exploitationFamilleCultures = {
      VITIC: { code: t("modif-exploitation.error.required", "Champ obligatoire") },
    };
  }

  return errors;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withTranslation()(
    withFormik({
      mapPropsToValues: mapPropsToValues,
      validate: validate,
      validateOnMount: true,
      validateOnChange: true,
      validateOnBlur: false,
      handleSubmit: handleSubmit,
    })(ModifExploitationForm)
  )
);
